import { render } from "./BaseDialog.vue?vue&type=template&id=cb666a16&scoped=true"
import script from "./BaseDialog.vue?vue&type=script&lang=js"
export * from "./BaseDialog.vue?vue&type=script&lang=js"

import "./BaseDialog.vue?vue&type=style&index=0&id=cb666a16&scoped=true&lang=css"

import exportComponent from "D:\\vue\\Vue_Lessons\\coachApps\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cb666a16"]])

export default __exports__